export default __webpack_public_path__ + "static/media/LogOut.ab8add69.svg";